export default () => ({
  locale: 'ja',
  globalLoading: false,
});
